import $ from "jquery";
import axios from "axios";

const urlUnsubscribe = '/rest/profile/unsubscribe';
const urlActiveSubscribe = '/rest/profile/active-subscribe';
const urlStripeSession = '/rest/stripe/link';

export const manageSubscription = () => {
    $(document).on('click', '.modal#unsubscribe .button.unsubscribe', function () {
        const button = $(this);

        axios.post(urlUnsubscribe, {licenseId: button.data('id')})
            .then(function () {
                window.location.reload();
            });
    });

    $(document).on('click', '.button.active-subscription', function () {
        const button = $(this);

        axios.post(urlActiveSubscribe, {licenseId: button.data('id')})
            .then(function () {
                window.location.reload();
            });
    });

    $('#stripe-manage-subscription-button').on('click', function () {
        const $target = $(this);

        axios.get(urlStripeSession, {
            params: {
                stripeCustomerId: $target.data('stripeCustomerId')
            }
        })
            .then(function (response) {
                if (!response.data.data) {
                    return;
                }

                if (!response.data.data.url) {
                    return;
                }

                window.location.href = response.data.data.url;
            })
            .catch(e => {
                console.log(e);
            });
    });

    $('#paddle-manage-subscription-button').on('click', function () {
        window.open($(this).attr('data-url'), '_blank');
    });
};
